import { Preferences } from '@capacitor/preferences';
import { useQueries } from '@tanstack/react-query';
import ChildrenSelection from 'components/children-selection/children-selection';
import LoadingScreen from 'components/loading-screen/loading-screen';
import NoChildren from 'components/no-children/no-children';
import Page from 'components/page/page';
import { useEffect, useState } from 'react';
import { getProfile } from 'services/profile';
import { getMySubscription } from 'services/subscription';
import ChildrenDashboard from './children/dashboard';

/* eslint-disable-next-line */
export interface DashboardProps {}

export function Dashboard(props: DashboardProps) {
  const [childMode, setChildMode] = useState<string | null>(null);
  const [childModeSetted, setChildModeSetted] = useState(false);
  const [
    { data: dataProfile, isLoading: isLoadingProfile, isPending: profilePending },
    { data: dataSubscription, isLoading: isLoadingSubscription },
  ] = useQueries({
    queries: [
      { queryKey: ['getProfile'], queryFn: getProfile, staleTime: 0 },
      { queryKey: ['getMySubscription'], queryFn: getMySubscription, staleTime: 0 },
    ],
  });

  
  useEffect(() => {
    Preferences.get({ key: 'child_mode' }).then(({ value }) => {
      if (value && value !== 'null') setChildMode(value);
      setChildModeSetted(true);
    });
  }, []);

  // useEffect(() => {
  //   BlockerPlugin.checkAccessibilityPermission().then(({ isGranted }) => {
  //     if (!isGranted) {
  //       BlockerPlugin.requestAccessibilityPermission();
  //     } else {
  //       alert('Admin privileges already granted');
  //     }
  //   });
  // }, []);

  // useEffect(() => {
  //   BlockerPlugin.isAdminActive().then(({ isActive }) => {
  //     if (!isActive) {
  //       BlockerPlugin.requestAdminPrivileges();
  //     } else {
  //       alert('Admin privileges already granted');
  //     }
  //   });
  // }, []);

  if (isLoadingProfile || !childModeSetted || isLoadingSubscription) {
    return <LoadingScreen />;
  }
  // if (!dataSubscription && !isLoadingSubscription) {
  //   return <Navigate to="/subscribe" />;
  // }
  if (childMode) {
    return <ChildrenDashboard childrenId={childMode} />;
  }
  if (dataProfile?.childrens && dataProfile.childrens.length === 0) {
    return <NoChildren />;
  }
  return (
    <Page>
      <ChildrenSelection
        loading={profilePending}
        childrens={dataProfile?.childrens ?? []}
        maxChildren={dataSubscription?.childrenCount || 4}
      />
    </Page>
  );
}

export default Dashboard;
